export enum WIDGET_CONTENT_LIST {
    /**
     * @value The widget surfaces content filtering on specific authors
     * @description Helper text for the Author criterion checkbox in the Content List widget settings.
     */
    CONTENT_LIST_CRITERIA_AUTHOR_HELPER = 'DESIGNER.CONTENT_LIST_CRITERIA_AUTHOR_HELPER',
    /**
     * @value The widget surfaces content filtering on a specific content type
     * @description Helper text for the Content Types criterion checkbox in the Content List widget settings.
     */
    CONTENT_LIST_CRITERIA_CONTENT_TYPES_HELPER = 'DESIGNER.CONTENT_LIST_CRITERIA_CONTENT_TYPES_HELPER',
    /**
     * @value Content marked as "Featured" will surface
     * @description Helper text for the Featured criterion checkbox in the Content List widget settings.
     */
    CONTENT_LIST_CRITERIA_FEATURED_HELPER = 'DESIGNER.CONTENT_LIST_CRITERIA_FEATURED_HELPER',
    /**
     * @value Content that are highlighted for the connected user will surface
     * @description Helper text for the Highlighted For criterion checkbox in the Content List widget settings.
     */
    CONTENT_LIST_CRITERIA_HIGHLIGHTED_HELPER = 'DESIGNER.CONTENT_LIST_CRITERIA_HIGHLIGHTED_HELPER',
    /**
     * @value By default, content comes from the current site.
     * @description Default description in the Source section of the Content List widget settings, explaining the default source behavior.
     */
    CONTENT_LIST_SOURCE_DEFAULT_DESCRIPTION = 'DESIGNER.CONTENT_LIST_SOURCE_DEFAULT_DESCRIPTION',
    /**
     * @value Show content from favorite sites only
     * @description Label for the switch to restrict content to the user's favorite sites only, in the Content List widget settings.
     */
    CONTENT_LIST_SOURCE_ONLY_FAVORITES_LABEL = 'DESIGNER.CONTENT_LIST_SOURCE_ONLY_FAVORITES_LABEL',
    /**
     * @value Show content from site selection
     * @description Label for the radio button to show content from a selected list of sites, in the Content List widget settings.
     */
    CONTENT_LIST_SOURCE_SELECTED_INSTANCES_LABEL = 'DESIGNER.CONTENT_LIST_SOURCE_SELECTED_INSTANCES_LABEL',
    /**
     * @value Show content from site siblings
     * @description Label for the radio button to show content from sibling sites, in the Content List widget settings.
     */
    CONTENT_LIST_SOURCE_SIBLING_INSTANCES_LABEL = 'DESIGNER.CONTENT_LIST_SOURCE_SIBLING_INSTANCES_LABEL',
    /**
     * @value Content list settings
     */
    CONTENT_LIST_WIDGET_SETTINGS_TITLE = 'DESIGNER.CONTENT_LIST_WIDGET_SETTINGS_TITLE',
    /**
     * @value Content will appear here based on your manual selection or dynamic criteria.
     * @description Description that will be used on empty state of content-list widgets within the content editor. It describes the behavior of the widget. It is a shared translation, every list widgets should have the same base translation. Key pattern, for reference: DESIGNER.WIDGET_XXX_EMPTY_STATE_DESCRIPTION
     */
    EMPTY_STATE_DESCRIPTION = 'DESIGNER.WIDGET_CONTENT_LIST_EMPTY_STATE_DESCRIPTION',
    /**
     * @value Last published date
     * @description Label for the sort-by publication date option in the content list widget sort settings
     */
    SORT_PUBLICATION_DATE_LABEL = 'WIDGET_CONTENT_LIST.SORT_PUBLICATION_DATE_LABEL',
    /**
     * @value No content yet
     */
    WRITER_MODE_EMPTY_STATE_TITLE = 'CONTENT_ADMIN.NO_CONTENT_TITLE',
}
